import axios from "axios";

export function addAuditLog(formData) {
  axios
	.post(process.env.REACT_APP_API_URL + "/api/auditlog", formData)
	.then(res => {
	  if (res.data.status === "0") {
		//setAlert(res.data.msg, "success");
		//props.history.push("/cases/view/" + res.data.id);
	  }else {
		//setAlert(res.data.msg, "danger");
		//setShowConfirm(false);
	  }
	})
	.catch(err => {
	  //setAlert(err, "danger");
	});
}